(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sh-lieferumfang"] && !Shopify.designMode) return;
  try {
    (() => {
    const QUERY = `query BundleComponents($id: ID!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
      node(id: $id) {
        ... on ProductVariant {
          components(first: 30) {
            nodes {
              quantity
              productVariant {
                price { amount }
                image { url altText }
                product {
                  id
                  title
                  handle
                  featuredImage { url altText }
                  gratis: metafield(namespace: "custom", key: "sh_pre_order_text") { value }
                  freisteller: metafield(namespace: "custom", key: "sh_freisteller") {
                    reference { ... on MediaImage { image { url altText } } }
                  }
                }
              }
            }
          }
        }
      }
    }`;

    const escapeHtml = (value) => String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

    const formatWithDelimiters = (number, precision, thousands, decimal) => {
      const fixed = Math.abs(number / 100).toFixed(precision);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return precision > 0 ? parts.join(decimal) : parts[0];
    };

    const formatMoney = (cents, fmt) => {
      const format = fmt || '{{amount}}';
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, placeholder) => {
        switch (placeholder) {
          case 'amount':
            return formatWithDelimiters(cents, 2, ',', '.');
          case 'amount_no_decimals':
            return formatWithDelimiters(cents, 0, ',', '.');
          case 'amount_with_comma_separator':
            return formatWithDelimiters(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return formatWithDelimiters(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return formatWithDelimiters(cents, 2, "'", '.');
          case 'amount_no_decimals_with_space_separator':
            return formatWithDelimiters(cents, 0, ' ', ',');
          case 'amount_with_space_separator':
            return formatWithDelimiters(cents, 2, ' ', ',');
          case 'amount_with_period_and_space_separator':
            return formatWithDelimiters(cents, 2, ' ', '.');
          default:
            return match;
        }
      });
    };

    const numericId = (gid) => {
      const match = String(gid || '').match(/(\d+)$/);
      return match ? match[1] : '';
    };

    const readConfig = (root) => {
      const node = root.querySelector('[data-sh-lfu-config]');
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    };

    const fetchComponents = async (config) => {
      const response = await fetch(`https://${config.shop}/api/2026-07/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': config.token,
        },
        body: JSON.stringify({
          query: QUERY,
          variables: {
            id: `gid://shopify/ProductVariant/${config.variantId}`,
            country: String(config.country || 'DE').toUpperCase(),
            language: String(config.language || 'DE').split('-')[0].toUpperCase(),
          },
        }),
      });
      const payload = await response.json();
      const nodes = payload && payload.data && payload.data.node && payload.data.node.components
        ? payload.data.node.components.nodes
        : [];
      return nodes.map((node) => {
        const variant = node.productVariant || {};
        const item = variant.product || {};
        const freisteller = item.freisteller && item.freisteller.reference && item.freisteller.reference.image;
        const featured = item.featuredImage || variant.image || null;
        const image = freisteller || featured;
        const amount = variant.price && variant.price.amount ? variant.price.amount : '0';
        return {
          id: numericId(item.id),
          title: item.title || '',
          handle: item.handle || '',
          quantity: Number(node.quantity) || 1,
          gratis: item.gratis && item.gratis.value ? String(item.gratis.value).trim() : '',
          image: image && image.url ? image.url : '',
          alt: (image && image.altText) || item.title || '',
          priceCents: Math.round(parseFloat(amount) * 100),
        };
      }).filter((item) => item.id);
    };

    const splitRows = (items, freeIds) => {
      const free = new Set(String(freeIds || '').split(',').filter(Boolean));
      const row1 = [];
      const row2 = [];
      items.forEach((item) => {
        if (free.has(item.id)) row2.push(item);
        else row1.push(item);
      });
      return { row1, row2 };
    };

    const quantityTotal = (items) => items.reduce((sum, item) => sum + (Number(item.quantity) || 1), 0);

    const formatCount = (template, total) => {
      let text = String(template || '').replace('[count]', String(total));
      if (total === 1) text = text.replace(/\bProdukte\b/g, 'Produkt');
      return text;
    };

    const previewHtml = (items, limit) => {
      const shown = items.slice(0, limit);
      const parts = [];
      shown.forEach((item, index) => {
        if (index > 0) parts.push('<span class="sh-lfu__preview-plus">+</span>');
        const image = item.image
          ? `<img class="sh-lfu__preview-image" src="${escapeHtml(item.image)}" alt="" width="120" height="120" loading="lazy">`
          : '';
        const qty = item.quantity > 1
          ? `<span class="sh-lfu__preview-qty">${item.quantity}X</span>`
          : '';
        parts.push(`<span class="sh-lfu__preview-item">${qty}${image}</span>`);
      });
      const rest = items.length - shown.length;
      if (rest > 0) parts.push(`<span class="sh-lfu__preview-more">+${rest}</span>`);
      return parts.join('');
    };

    const cardHtml = (item, moneyFormat, reserveBadge, showGratis) => {
      const modalId = `sh-lfu-qv-${item.id}`;
      const gratisText = showGratis ? item.gratis : '';
      const badge = gratisText
        ? `<span class="sh-pre-order-products__badge">${escapeHtml(gratisText)}</span>`
        : (reserveBadge ? '<span class="sh-pre-order-products__badge-spacer" aria-hidden="true"></span>' : '');
      const qty = item.quantity > 1
        ? `<span class="sh-pre-order-products__qty">${item.quantity}X</span>`
        : '';
      const image = item.image
        ? `<img class="sh-pre-order-products__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.alt)}" width="160" height="160" loading="lazy">`
        : '';
      const priceClass = gratisText ? ' sh-pre-order-products__price--strike' : '';
      const cardClass = gratisText ? ' sh-pre-order-products__card--gratis' : '';
      return `<button type="button" class="sh-pre-order-products__card${cardClass}" data-sh-lfu-qv="${escapeHtml(item.handle)}" data-sh-lfu-modal="${modalId}" aria-haspopup="dialog" aria-controls="${modalId}">
        ${badge}
        <div class="sh-pre-order-products__media">${qty}${image}</div>
        <p class="sh-pre-order-products__title">${escapeHtml(item.title)}</p>
        <p class="sh-pre-order-products__price${priceClass}">${escapeHtml(formatMoney(item.priceCents, moneyFormat))}</p>
      </button>`;
    };

    const rowHtml = (items, label, moneyFormat, reserveBadge, showGratis) => {
      if (!items.length) return '';
      const useSlider = items.length > 3;
      const pageCount = useSlider ? Math.max(1, items.length - 2) : 1;
      const rootClass = useSlider ? 'sh-pre-order-products--slider' : 'sh-pre-order-products--static';
      const badgeClass = reserveBadge ? ' sh-pre-order-products--badge-row' : '';
      const sliderAttrs = useSlider
        ? ` data-sh-pre-order-slider data-visible-count="3.5" data-page-count="${pageCount}"`
        : '';
      const cards = items.map((item, index) => {
        const plus = index < items.length - 1
          ? '<span class="sh-pre-order-products__plus" aria-hidden="true">+</span>'
          : '';
        return `<div class="sh-pre-order-products__item">${cardHtml(item, moneyFormat, reserveBadge, showGratis)}${plus}</div>`;
      }).join('');
      let dots = '';
      if (useSlider && pageCount > 1) {
        const buttons = items.slice(0, pageCount).map((_, index) => {
          const active = index === 0 ? ' is-active' : '';
          return `<button type="button" class="sh-pre-order-products__dot${active}" data-index="${index}" aria-label="${index + 1}"></button>`;
        }).join('');
        dots = `<div class="sh-pre-order-products__dots" data-sh-pre-order-dots role="tablist">${buttons}</div>`;
      }
      const labelClass = reserveBadge ? 'sh-lfu__row-label--2' : 'sh-lfu__row-label--1';
      const labelHtml = label ? `<p class="sh-pre-order__row-label ${labelClass}">${escapeHtml(label)}</p>` : '';
      const rowClass = reserveBadge ? ' sh-pre-order__row--gratis' : '';
      return `<div class="sh-pre-order__row${rowClass}">${labelHtml}<div class="sh-pre-order-products ${rootClass}${badgeClass}"${sliderAttrs}><div class="sh-pre-order-products__track">${cards}</div>${dots}</div></div>`;
    };

    const paint = (root, config, items) => {
      const rows = splitRows(items, config.freeIds);
      const meta = root.querySelector('[data-sh-lfu-meta]');
      const count = root.querySelector('[data-sh-lfu-count]');
      const free = root.querySelector('[data-sh-lfu-free]');
      const preview = root.querySelector('[data-sh-lfu-preview]');
      const panel = root.querySelector('[data-sh-lfu-rows]');
      if (!panel || !count || !free || !meta) return;

      count.textContent = formatCount(config.countText, quantityTotal(rows.row1));
      if (rows.row2.length > 0 && config.freeText) {
        free.hidden = false;
        free.textContent = formatCount(config.freeText, quantityTotal(rows.row2));
      } else {
        free.hidden = true;
        free.textContent = '';
      }
      meta.hidden = false;

      if (preview && config.showPreview) {
        preview.innerHTML = previewHtml(rows.row1.concat(rows.row2), Number(config.previewLimit) || 8);
      }

      panel.innerHTML = [
        rowHtml(rows.row1, config.setLabel, config.moneyFormat, false, false),
        rowHtml(rows.row2, config.freeLabel, config.moneyFormat, true, true),
      ].join('');

      root.hidden = false;
      document.dispatchEvent(new CustomEvent('sh:pre-order:bind'));

      if (config.openByDefault && !root.open) {
        root.open = true;
        root.setAttribute('data-pqa-open', '');
        const content = root.querySelector('[data-qa-content]');
        if (content) content.style.maxHeight = 'none';
      }
    };

    // One popup per product. A second click reuses the modal already on the page.
    // The quick-view template ids the dialog sh-pre-order-qv-*, while the card
    // asks for sh-lfu-qv-*, so a plain getElementById never hit and every click
    // appended another dialog.
    const quickviewRequests = new Map();

    const ensureQuickview = (handle, modalId) => {
      const existing = document.getElementById(modalId);
      if (existing) return existing;
      const inflight = quickviewRequests.get(modalId);
      if (inflight) return inflight;

      const request = (async () => {
        const response = await fetch(`/products/${encodeURIComponent(handle)}?view=lfu-quickview`);
        const html = await response.text();
        const holder = document.createElement('div');
        holder.innerHTML = html;
        const modal = holder.querySelector('modal-dialog');
        if (!modal) return null;
        const already = document.getElementById(modalId) || document.getElementById(modal.id);
        if (already) {
          already.id = modalId;
          return already;
        }
        modal.id = modalId;
        document.body.appendChild(modal);
        return modal;
      })().finally(() => {
        quickviewRequests.delete(modalId);
      });

      quickviewRequests.set(modalId, request);
      return request;
    };

    const bindQuickviews = (root) => {
      if (root.dataset.shLfuQvBound === '1') return;
      root.dataset.shLfuQvBound = '1';
      root.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-sh-lfu-qv]');
        if (!button || !root.contains(button)) return;
        event.preventDefault();
        const handle = button.getAttribute('data-sh-lfu-qv');
        const modalId = button.getAttribute('data-sh-lfu-modal');
        if (!handle || !modalId) return;
        const modal = await ensureQuickview(handle, modalId);
        if (!modal) return;
        document.dispatchEvent(new CustomEvent('sh:lfu:qv-open', {
          detail: { modal, opener: button },
        }));
      });
    };

    const renderRoot = async (root) => {
      const config = readConfig(root);
      const hasContent = !!(config && config.hasContent);
      if (!config || !config.token || !config.variantId) {
        if (!hasContent) root.remove();
        return;
      }
      bindQuickviews(root);
      try {
        const items = await fetchComponents(config);
        if (!items.length) {
          if (!hasContent) root.remove();
          return;
        }
        paint(root, config, items);
      } catch (error) {
        if (!hasContent) root.remove();
      }
    };

    const boot = () => {
      document.querySelectorAll('[data-sh-lfu]').forEach((root) => {
        if (root.dataset.shLfuBooted === '1') return;
        root.dataset.shLfuBooted = '1';
        renderRoot(root);
      });
    };

    document.addEventListener('on:variant:change', (event) => {
      if (event.target.closest('[data-sh-pre-order-qv], [data-sh-lfu]')) return;
      const variant = event.detail && event.detail.variant;
      if (!variant || !variant.id) return;
      document.querySelectorAll('[data-sh-lfu]').forEach((root) => {
        const node = root.querySelector('[data-sh-lfu-config]');
        if (!node) return;
        const config = readConfig(root);
        if (!config || String(config.variantId) === String(variant.id)) return;
        config.variantId = variant.id;
        config.openByDefault = root.open;
        node.textContent = JSON.stringify(config);
        renderRoot(root);
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
